import React from "react";

const FootballMatchDetails = ({ matches, userNames, styles }) => {
  return matches.map((match, matchIndex) => (
    <div key={matchIndex} style={{ marginBottom: "clamp(18px, 4vw, 25px)" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "clamp(15px, 4vw, 20px)",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <h4
          style={{
            color: "#2c3e50",
            margin: 0,
            fontSize: "clamp(16px, 3.5vw, 20px)",
          }}
        >
          Match #{matchIndex + 1}
        </h4>
        <span
          style={{
            backgroundColor:
              match.winner === "user"
                ? "#27ae60"
                : match.winner === "opponent"
                ? "#e74c3c"
                : "#95a5a6",
            color: "white",
            padding: "clamp(3px, 1vw, 4px) clamp(10px, 2.5vw, 12px)",
            borderRadius: "20px",
            fontSize: "clamp(11px, 2.2vw, 12px)",
            fontWeight: "600",
          }}
        >
          {match.winner === "user"
            ? "WIN"
            : match.winner === "opponent"
            ? "LOSS"
            : "DRAW"}
        </span>
      </div>

      {/* Team Names & Score */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#f8f9fa",
          padding: "clamp(15px, 4vw, 20px)",
          borderRadius: "12px",
          marginBottom: "clamp(15px, 4vw, 20px)",
          border: "2px solid #e9ecef",
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        <div style={{ textAlign: "center", flex: 1, minWidth: "120px" }}>
          <h3
            style={{
              color: "#2c3e50",
              margin: "0 0 clamp(8px, 2vw, 10px) 0",
              fontSize: "clamp(16px, 3.5vw, 20px)",
            }}
          >
            {match.userTeamName || "Your Team"}
          </h3>
          <div
            style={{
              fontSize: "clamp(28px, 7vw, 36px)",
              fontWeight: "bold",
              color: "#27ae60",
            }}
          >
            {match.userGoals + match.userPenalties}
          </div>
          <div
            style={{ fontSize: "clamp(11px, 2.2vw, 12px)", color: "#6c757d" }}
          >
            Goals: {match.userGoals} | Penalties: {match.userPenalties}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "clamp(18px, 4.5vw, 24px)",
            fontWeight: "bold",
            color: "#6c757d",
            minWidth: "60px",
            justifyContent: "center",
          }}
        >
          VS
        </div>
        <div style={{ textAlign: "center", flex: 1, minWidth: "120px" }}>
          <h3
            style={{
              color: "#2c3e50",
              margin: "0 0 clamp(8px, 2vw, 10px) 0",
              fontSize: "clamp(16px, 3.5vw, 20px)",
            }}
          >
            {match.opponentTeamName || "Opponent Team"}
          </h3>
          <div
            style={{
              fontSize: "clamp(28px, 7vw, 36px)",
              fontWeight: "bold",
              color: "#e74c3c",
            }}
          >
            {match.opponentGoals + match.opponentPenalties}
          </div>
          <div
            style={{ fontSize: "clamp(11px, 2.2vw, 12px)", color: "#6c757d" }}
          >
            Goals: {match.opponentGoals} | Penalties: {match.opponentPenalties}
          </div>
        </div>
      </div>

      {/* Match Info */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          gap: "clamp(12px, 3vw, 15px)",
          marginBottom: "clamp(15px, 4vw, 20px)",
          fontSize: "clamp(13px, 2.5vw, 15px)",
        }}
      >
        <p>
          <strong>Match Type:</strong> {match.matchType}
        </p>
        <p>
          <strong>Duration:</strong> {match.duration} minutes
        </p>
        <p>
          <strong>Total Players:</strong>{" "}
          {(match.userTeam?.length || 0) + (match.opponentTeam?.length || 0)}
        </p>
      </div>

      {/* Goal Events */}
      {match.goalEvents && match.goalEvents.length > 0 && (
        <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            ⚽ Goal Events
          </h4>
          <table style={styles.setsTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Minute</th>
                <th style={styles.tableTh}>Team</th>
                <th style={styles.tableTh}>Scorer</th>
                <th style={styles.tableTh}>Assist</th>
              </tr>
            </thead>
            <tbody>
              {match.goalEvents.map((goal, index) => (
                <tr key={index}>
                  <td style={styles.tableTd}>{goal.minute}'</td>
                  <td style={styles.tableTd}>
                    {goal.team === "user"
                      ? match.userTeamName
                      : match.opponentTeamName}
                  </td>
                  <td style={styles.tableTd}>{goal.scorer}</td>
                  <td style={styles.tableTd}>{goal.assist || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Penalty Events */}
      {match.penaltyEvents && match.penaltyEvents.length > 0 && (
        <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            🥅 Penalty Shootout
          </h4>
          <table style={styles.setsTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Team</th>
                <th style={styles.tableTh}>Player</th>
                <th style={styles.tableTh}>Result</th>
              </tr>
            </thead>
            <tbody>
              {match.penaltyEvents.map((penalty, index) => (
                <tr key={index}>
                  <td style={styles.tableTd}>
                    {penalty.team === "user"
                      ? match.userTeamName
                      : match.opponentTeamName}
                  </td>
                  <td style={styles.tableTd}>{penalty.scorer}</td>
                  <td style={styles.tableTd}>
                    <span
                      style={{
                        color: penalty.scored ? "#27ae60" : "#e74c3c",
                        fontWeight: "bold",
                      }}
                    >
                      {penalty.scored ? "⚽ SCORED" : "❌ MISSED"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Team Rosters */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "clamp(12px, 4vw, 20px)",
        }}
      >
        <div>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(8px, 2vw, 10px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            👥 {match.userTeamName || "Your Team"}
          </h4>
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "clamp(12px, 3vw, 15px)",
              borderRadius: "8px",
            }}
          >
            {match.userTeam && match.userTeam.length > 0 ? (
              match.userTeam.map((player, index) => {
                const playerName = player.userId
                  ? userNames[player.userId] || player.name
                  : player.name;
                return (
                  <div
                    key={index}
                    style={{
                      padding: "clamp(6px, 1.5vw, 8px) 0",
                      borderBottom: "1px solid #dee2e6",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "clamp(12px, 2.5vw, 14px)",
                    }}
                  >
                    <span>
                      <strong>#{player.number}</strong> {playerName}
                      {player.isCustom && (
                        <span
                          style={{
                            color: "#6c757d",
                            fontSize: "clamp(11px, 2vw, 12px)",
                            marginLeft: "5px",
                          }}
                        >
                          (Custom)
                        </span>
                      )}
                    </span>
                    <span
                      style={{
                        fontSize: "clamp(11px, 2vw, 12px)",
                        color: "#6c757d",
                      }}
                    >
                      {player.position}
                    </span>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  color: "#6c757d",
                  fontStyle: "italic",
                  fontSize: "clamp(12px, 2.5vw, 14px)",
                }}
              >
                No players added
              </div>
            )}
          </div>
        </div>
        <div>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(8px, 2vw, 10px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            👥 {match.opponentTeamName || "Opponent Team"}
          </h4>
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "clamp(12px, 3vw, 15px)",
              borderRadius: "8px",
            }}
          >
            {match.opponentTeam && match.opponentTeam.length > 0 ? (
              match.opponentTeam.map((player, index) => {
                const playerName = player.userId
                  ? userNames[player.userId] || player.name
                  : player.name;
                return (
                  <div
                    key={index}
                    style={{
                      padding: "clamp(6px, 1.5vw, 8px) 0",
                      borderBottom: "1px solid #dee2e6",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "clamp(12px, 2.5vw, 14px)",
                    }}
                  >
                    <span>
                      <strong>#{player.number}</strong> {playerName}
                      {player.isCustom && (
                        <span
                          style={{
                            color: "#6c757d",
                            fontSize: "clamp(11px, 2vw, 12px)",
                            marginLeft: "5px",
                          }}
                        >
                          (Custom)
                        </span>
                      )}
                    </span>
                    <span
                      style={{
                        fontSize: "clamp(11px, 2vw, 12px)",
                        color: "#6c757d",
                      }}
                    >
                      {player.position}
                    </span>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  color: "#6c757d",
                  fontStyle: "italic",
                  fontSize: "clamp(12px, 2.5vw, 14px)",
                }}
              >
                No players added
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Match Summary */}
      <div
        style={{
          backgroundColor: "white",
          padding: "clamp(15px, 4vw, 20px)",
          borderRadius: "8px",
          marginTop: "clamp(15px, 4vw, 20px)",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        }}
      >
        <h4
          style={{
            color: "#2c3e50",
            marginBottom: "clamp(12px, 3vw, 15px)",
            fontSize: "clamp(15px, 3vw, 18px)",
          }}
        >
          🏆 Match Summary
        </h4>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: "clamp(12px, 3vw, 15px)",
            fontSize: "clamp(12px, 2.5vw, 14px)",
          }}
        >
          <div>
            <strong>Winner:</strong>{" "}
            <span
              style={{
                color:
                  match.winner === "user"
                    ? "#27ae60"
                    : match.winner === "opponent"
                    ? "#e74c3c"
                    : "#6c757d",
                fontWeight: "bold",
              }}
            >
              {match.winner === "user"
                ? match.userTeamName || "Your Team"
                : match.winner === "opponent"
                ? match.opponentTeamName || "Opponent Team"
                : "Draw"}
            </span>
          </div>
          <div>
            <strong>Match Type:</strong> {match.matchType || "Regular"}
          </div>
          <div>
            <strong>Match Duration:</strong> {match.duration || 90} minutes
          </div>
          <div>
            <strong>Final Score:</strong>{" "}
            {(match.userGoals || 0) + (match.userPenalties || 0)} -{" "}
            {(match.opponentGoals || 0) + (match.opponentPenalties || 0)}
          </div>
          <div>
            <strong>Total Players:</strong>{" "}
            {(match.userTeam?.length || 0) + (match.opponentTeam?.length || 0)}
          </div>
        </div>
      </div>
    </div>
  ));
};

export default FootballMatchDetails;
